

import React from "react";
import { Layout } from "antd";
import {FlowStationSettings} from './FlowStationSettings'
import { Flowstations } from "./Flowstations";

const { Content, Sider } = Layout;
export const FlowstationBaseView = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={550}
            
             style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <Flowstations/>
                </div>
              </div>
            </div>
          </Sider>
          <Content>
         <FlowStationSettings/>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

